// A call to action on a project: dark, what to do on the left, the choices
// on the right. The opportunity's decision and, later, every action item a
// project asks of its owner look like this.

import { FC, ReactNode } from "react";
import { clsx } from "clsx";
import classes from "./ActionCard.module.less";

export const ActionCard: FC<{
    /** A small label over the title: what kind of call this is. */
    eyebrow?: ReactNode;
    title: ReactNode;
    lines?: ReactNode[];
    actions?: ReactNode;
    /** The user's work under the title: the asks and their answers. */
    children?: ReactNode;
    className?: string;
}> = ({ eyebrow, title, lines = [], actions, children, className }) => (
    <div className={clsx(classes.card, className)}>
        <div className={classes.top}>
            <div className={classes.text}>
                {eyebrow && <div className={classes.eyebrow}>{eyebrow}</div>}
                <div className={classes.title}>{title}</div>
                {lines.map((line, i) => (
                    <div key={i} className={classes.line}>
                        {line}
                    </div>
                ))}
            </div>
            {actions && <div className={classes.actions}>{actions}</div>}
        </div>
        {children && <div className={classes.body}>{children}</div>}
    </div>
);
